(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var _Affiliate = _interopRequireDefault(require("../../includes/Affiliate.js"));
var _Cookie = _interopRequireDefault(require("../../includes/Cookie.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
$(function () {
  var cookieInstance = new _Cookie["default"]();
  window.affiliate = new _Affiliate["default"](cookieInstance);
});

},{"../../includes/Affiliate.js":2,"../../includes/Cookie.js":3}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Affiliate = /*#__PURE__*/function () {
  function Affiliate(cookie) {
    _classCallCheck(this, Affiliate);
    this.Cookie = cookie;
    this.affiliateCampaignId = null;
    this.affiliateUserId = null;
    this.bannerId = null;
    // Check for the presence of hash paramater
    var lochash = location.hash.substr(1);
    if (lochash !== "" && lochash != undefined) {
      //if the #signup fragment found, cookie has already been set
      if (lochash === "signup") {
        // search for the cookie created on the widget to register affiliate visit
        this.affiliateUserId = this.Cookie.GetCookie("affiliateID");
      } else {
        // Check to see if hash is an aid (affiliate ID) value
        var b = lochash.split("aid_");
        if (b[1] !== undefined) {
          this.affiliateUserId = b[1].split("#")[0];
        }

        // Check to see if hash is an cid (Campaign ID) value
        var a = lochash.split("cid_");
        if (a[1] !== undefined) {
          this.affiliateCampaignId = a[1].split("#")[0];
        }
        this.bannerId = lochash.split("bid_")[1];
        this.send = false;
      }
      var postData = {};
      if (this.IsNumeric(this.affiliateUserId)) {
        postData.aid = this.affiliateUserId;
        this.send = true;
      }
      if (this.IsNumeric(this.affiliateCampaignId)) {
        postData.cid = this.affiliateCampaignId;
        this.send = true;
      }

      //check for banner click
      if (this.IsNumeric(this.bannerId)) {
        //Write the BannerId session Cookie
        this.Cookie.SetSessionCookie("bannerId", this.bannerId);
        postData.bid = this.bannerId;
        this.send = true;
      }
      if (this.send) {
        var anchor = document.createElement('a');
        anchor.href = document.referrer;
        postData.hostname = anchor.hostname;
        postData.referrer = document.referrer;
        postData.landingPage = window.location.pathname;
        postData.language = window.Language;
        $.ajax({
          type: "POST",
          cache: false,
          url: window.affiliateHandleUrl,
          data: postData,
          async: true
        });
      }
      if (this.IsNumeric(this.affiliateUserId)) {
        // Valid aid 
        // check to see if the hidden AID field is on page (found in the registration form)
        if ($('#AffiliateId').length) {
          // if yes, assign aid value
          $('#AffiliateId').val(this.affiliateUserId);
        }

        // also cookie in case of signup via google/facebook
        this.Cookie.SetCookie("affiliateID", this.affiliateUserId, 90);
        //writing an affiliate cookie means we need to remove any existing campaign cookies
        this.Cookie.DeleteCookie("affiliateCampaignId");
      } else {
        // No Affiliate ID found, so check for Campaign ID

        if (this.IsNumeric(this.affiliateCampaignId)) {
          // Valid CID 
          // check to see if the hidden CID field is on page
          if ($('#AffiliateCampaignId').length) {
            // if yes, assign CID value
            $('#AffiliateCampaignId').val(this.affiliateCampaignId);

            // also cookie in case of signup via google/facebook
            this.Cookie.SetCookie("affiliateCampaignId", this.affiliateCampaignId, 90);
            //writing a campaign cookie means we need to remove any existing affiliate cookies
            this.Cookie.DeleteCookie("affiliateID");
          }
        }
      }
      if (lochash === "signup") {
        // We need to open the signup popup
        window.Access.Login('signup');
      } else if (lochash === "login") {
        window.Access.Login();
      } else if (lochash === "loginforum_cbf") {
        window.Access.Login('loginforum_cbf');
      }
    }
  }
  return _createClass(Affiliate, [{
    key: "IsNumeric",
    value: function IsNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    }
  }, {
    key: "SignUpLinkClick",
    value: function SignUpLinkClick(link) {
      var dataOut = {};
      dataOut.link = link;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.signUpLinkUrl,
        async: true,
        data: dataOut
      });
      document.location.href = link;
    }
  }]);
}();
var _default = exports["default"] = Affiliate;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  return _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
}();
var _default = exports["default"] = Cookie;

},{}]},{},[1]);
